import { Content } from 'src/contexts/ContentContext';
import { Stack } from 'src/core/ui';
import { ModalBodyDataContainer } from 'src/modals/Modal/Modal.styled';
import { ContentId } from 'src/utils/constants/contentId';

export const AutoPoManagedTransferBody = () => {
  return (
    <ModalBodyDataContainer>
      <Stack direction="column" gap="xl">
        <Content id={ContentId.AutoPoManagedTransferConfirmation} />
      </Stack>
    </ModalBodyDataContainer>
  );
};
